import Vue from 'vue'
import VueI18n from 'vue-i18n'

import router from './router'
import store from './vuex/store'
import filters from './utils/filters'
import { scrollTo } from './utils/utils'

import './assets/styles/custom.scss'

// copy of element-ui/lib/theme-chalk/display.css providing classes for hiding elements
// rebuild to use our own breakpoints
// import './assets/styles/display.css'

import {
  Autocomplete,
  Button,
  ButtonGroup,
  Card,
  Checkbox,
  Col,
  Collapse,
  CollapseItem,
  DatePicker,
  Dialog,
  Form,
  FormItem,
  Icon,
  Input,
  Loading,
  Message,
  Notification,
  Option,
  OptionGroup,
  Radio,
  RadioButton,
  RadioGroup,
  Row,
  Select,
  Step,
  Steps,
  Table,
  TableColumn,
  Tooltip
} from 'element-ui'
import './assets/styles/material_icons.css'
import deLocale from 'element-ui/lib/locale/lang/de'
import enLocale from 'element-ui/lib/locale/lang/en'
import ElementLocale from 'element-ui/lib/locale'
import de from './locales/de.json'
import en from './locales/en.json'

import App from './App'

var after = require('lodash/after')
var clone = require('lodash/clone')
var cloneDeep = require('lodash/cloneDeep')
var concat = require('lodash/concat')
var each = require('lodash/each')
var filter = require('lodash/filter')
var find = require('lodash/find')
var flatMap = require('lodash/flatMap')
var groupBy = require('lodash/groupBy')
var indexOf = require('lodash/indexOf')
var isArray = require('lodash/isArray')
var map = require('lodash/map')
var merge = require('lodash/merge')
var orderBy = require('lodash/orderBy')
var range = require('lodash/range')
var sumBy = require('lodash/sumBy')
var union = require('lodash/union')
var uniqBy = require('lodash/uniqBy')

function isValidForm (form) {
  let isValid = true
  if (form.validate) {
    form.validate((valid) => {
      if (valid) {
        isValid = true
      } else {
        isValid = false
      }
    })
  }
  return isValid
}

var messages = {
  en: {
    dateFormat: 'dd/MM/yyyy',
    dateMask: '##/##/####',
    firstDayOfWeek: '7',
    ibe: en.ibe,
    rules: en.rules,
    ...enLocale
  },
  de: {
    dateFormat: 'dd.MM.yyyy',
    dateMask: '##.##.####',
    firstDayOfWeek: '1',
    ibe: de.ibe,
    rules: de.rules,
    ...deLocale
  }
}

filters.create()

Vue.use(VueI18n)
Vue.config.lang = window.initData.language
Vue.config.fallbackLang = 'de'

Vue.config.debug = !!(window.initData.debugMode & (1 << 2))
Vue.config.devtools = !!(window.initData.debugMode & (1 << 3))

var i18n = new VueI18n({
  locale: window.initData.language,
  messages,
  silentTranslationWarn: !(window.initData.debugMode & (1 << 4)),
  missing: missing
})

function missing (locale, key) {
  return (window.initData.debugMode & (1 << 5)) ? key : ''
}

ElementLocale.i18n(key => i18n.t(key))

Vue.use(Autocomplete)
Vue.use(Button)
Vue.use(ButtonGroup)
Vue.use(Card)
Vue.use(Checkbox)
Vue.use(Col)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(DatePicker)
Vue.use(Dialog)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Icon)
Vue.use(Input)
Vue.use(Option)
Vue.use(OptionGroup)
Vue.use(Radio)
Vue.use(RadioButton)
Vue.use(RadioGroup)
Vue.use(Row)
Vue.use(Select)
Vue.use(Step)
Vue.use(Steps)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Tooltip)

Vue.use(Loading.directive)

Vue.prototype.$notify = Notification
Vue.prototype.$message = Message
Vue.prototype.$isValidForm = isValidForm
Vue.prototype.$scrollTo = scrollTo

Vue.prototype._after = after
Vue.prototype._clone = clone
Vue.prototype._cloneDeep = cloneDeep
Vue.prototype._concat = concat
Vue.prototype._each = each
Vue.prototype._filter = filter
Vue.prototype._find = find
Vue.prototype._flatMap = flatMap
Vue.prototype._groupBy = groupBy
Vue.prototype._indexOf = indexOf
Vue.prototype._isArray = isArray
Vue.prototype._map = map
Vue.prototype._merge = merge
Vue.prototype._orderBy = orderBy
Vue.prototype._range = range
Vue.prototype._sumBy = sumBy
Vue.prototype._union = union
Vue.prototype._uniqBy = uniqBy

/* eslint-disable no-new */
new Vue({
  el: '#bookingApp',
  router,
  i18n,
  store,
  filters,
  render: h => h(App)
})
